import type {OperationHealthDto} from '@devmil/contracts';
import {useId} from 'react';

import {
  formatTimeOfDay,
  HEALTH_CLASS,
  HEALTH_LABEL,
  UNAVAILABLE,
} from '../../lib/format.js';

/**
 * Saúde da operação. Enquanto a fonte for fixture, nada aqui prova estado
 * externo, e o rótulo `AGORA` no cabeçalho é o que avisa isso.
 *
 * Backup não verificado e teste de restauração sem data aparecem como
 * `Indisp.`: fingir um horário aqui seria a pior mentira da tela inteira.
 */
export const OperationHealth = ({health}: {health: OperationHealthDto}) => {
  const headingId = useId();

  const rows: ReadonlyArray<[label: string, value: string, className: string]> =
    [
      [
        'Token e permissões Meta',
        HEALTH_LABEL[health.metaToken],
        HEALTH_CLASS[health.metaToken],
      ],
      [
        'Fila de publicação',
        `${health.publishQueue.uncertain} INCERTOS`,
        health.publishQueue.uncertain === 0 ? 'dm-ok' : 'dm-ok is-degraded',
      ],
      [
        'Webhooks e ordenação',
        HEALTH_LABEL[health.webhooks],
        HEALTH_CLASS[health.webhooks],
      ],
      [
        'Último backup verificado',
        health.lastVerifiedBackupAt
          ? formatTimeOfDay(health.lastVerifiedBackupAt)
          : UNAVAILABLE,
        health.lastVerifiedBackupAt ? 'dm-ok' : 'dm-ok is-degraded',
      ],
      [
        'Próximo teste de restauração',
        health.nextRestoreDrillInDays === null
          ? UNAVAILABLE
          : `${health.nextRestoreDrillInDays} DIAS`,
        health.nextRestoreDrillInDays === null ? 'dm-ok is-degraded' : 'dm-ok',
      ],
    ];

  return (
    <section className="dm-panel" aria-labelledby={headingId}>
      <div className="dm-panel-head">
        <h2 id={headingId}>Saúde da operação</h2>
        <span className="dm-illustrative">AGORA</span>
      </div>
      <ul className="dm-checklist" aria-labelledby={headingId}>
        {rows.map(([label, value, className]) => (
          <li key={label}>
            <span>{label}</span>
            <strong className={className}>{value}</strong>
          </li>
        ))}
      </ul>
    </section>
  );
};
